import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { resetDatabase } from "./Reset";
import { useLogout } from "./hooks/useLogout";
import { useCheckPassword } from "./hooks/useCheckPassword";
import { useAuthContext } from "./hooks/useAuthContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function PasswordModal({ show, onHide }) {
    const [password, setPassword] = useState("");
    const { user } = useAuthContext();
    const { checkPassword, success, isLoading, error } = useCheckPassword();
    const { logout } = useLogout();


    const handleChange = (e) => {
        setPassword(e.target.value);
    };

    useEffect(() => {
        async function handleReset() {
            // Check the value of success when it changes
            if (success) {
                const resetSuccess = await resetDatabase(user, logout);
                if (resetSuccess!== false) window.location.reload(true);
            }
        }
        handleReset();
    }, [success, logout, user]);

    const handleConfirm = async (e) => {
        e.preventDefault();

        await checkPassword(user.username, password);
        // Clear password after button press.
        setPassword("");


    };

    const handleCancel = () => {
        setPassword("");
        onHide();
    }

    useEffect(() => {
        if (error) {
            toast.error(error);
        }
    }, [error]);



    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>Återställ databasen</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>

                    <p className="modalP">
                        Vill du verkligen återställa databasen?
                    </p>
                    <p className="modalP-caution-text">
                        Detta kommer ta bort alla streck, och alla kommentarer. Detta går inte att ångra.
                        <br/>
                        Topp 3 genom tiderna-strecken kommer inte tas bort.
                    </p>
                    <form>

                        <input
                            type="password"
                            value={password}
                            onChange={handleChange}
                            placeholder="Skriv in ditt lösenord"
                            autoComplete="on"
                        />
                    </form>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button className="modalBtn" variant="secondary" onClick={handleCancel}>
                    Avbryt
                </Button>
                <Button disabled={isLoading || !password} variant="danger" onClick={handleConfirm}>
                    Återställ databasen
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default PasswordModal;
